import { configureStore } from "@reduxjs/toolkit";
import showSideBarReducer from "./showSideBarSlice";
import user from "./userSlice";
import paymentCategories from "./paymentCategoriesSlice";
import nin from "./ninSlice";

export default configureStore({
  reducer: {
    showSideBar: showSideBarReducer,
    user: user,
    paymentCategories: paymentCategories,
    nin: nin,
  },
});
